import React, { forwardRef, useState, useEffect } from 'react';

import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import { InputAdornment } from '@mui/material';

import StyledWrapper from './style';
import { Registry } from '../../FormBuilderLibrary';
import { stringToHTML } from '../utils';
import { getElementIcon } from '../utils';

export const MUINumberInput = forwardRef((props, ref) => {
	const { name, defaultValue, disabled, data, isFormBuilder } = props;

	const [value, setValue] = useState(defaultValue);
	const [refresh, setRefresh] = useState(defaultValue);

	function formatChangeEvent(number) {
		let value = number;
		value = value.replace(/[^0-9.]/g, '');
		if (value) {
			if (value[0] == 0 || value[0] == '.') {
				value = '';
			}
			if (value.includes('.')) {
				value = value.slice(0, 15);
				value = value.split('.');
				let numberPart = value.shift();
				let fractionalPart = value.join('');
				if (fractionalPart.length > 2) {
					fractionalPart = fractionalPart.slice(0, 2);
				}
				value = numberPart + '.' + fractionalPart;
				value = value.replace(/(?=(\d{3})+(\D))\B/g, ',');
			} else {
				value = value.slice(0, 12);
			}
		}
		return value;
	}

	function formatBlurEvent(number, isCurrency) {
		if (number && isCurrency) {
			if (number.includes('.')) {
				const parts = number.split('.');
				if (parts[1].length == 1) {
					number = number + '0';
				} else if (parts[1].length == 0) {
					number = number + '00';
				}
			} else {
				number = number + '.00';
			}
			number = number.replace(/(?=(\d{3})+(\D))\B/g, ',');
		}

		return number;
	}

	const handleChange = (event) => {
		const number = event.target.value;
		setValue(formatChangeEvent(number));
	};

	const handleBlur = (event) => {
		let number = event.target.value;
		setValue(formatBlurEvent(number, true));
	};

	useEffect(() => {
		setRefresh(!refresh);
	}, [props]);

	const parsedLabel = React.useMemo(() => stringToHTML(props?.data?.label), [props?.data?.label]);
	const parsedHelperText = React.useMemo(
		() => stringToHTML(props?.data?.help_message),
		[props?.data?.help_message]
	);

	return (
		<>
			{!disabled ? (
				props?.data?.description === 'currency' ? (
					<>
						<TextField
							error={props?.data?.error}
							required={props?.data?.required}
							id="outlined-error-helper-text"
							name={name}
							inputRef={ref}
							label={
								<>
									{isFormBuilder && getElementIcon(props.data?.key)}
									{parsedLabel?.[0] ? parsedLabel : props?.data?.label}
									{isFormBuilder && (
										<div>
											{props.data?.unique_identifier
												? `(ff-${props.data?.unique_identifier})`
												: `(tmp-${props.data?.temp_order})`}
										</div>
									)}
								</>
							}
							disabled={disabled}
							value={value}
							type="string"
							onBlur={handleBlur}
							onChange={handleChange}
							style={{ width: '100%' }}
							InputProps={{
								inputComponent: 'input',
								inputProps: {
									maxLength: 18
								},
								startAdornment: <InputAdornment position="start">$</InputAdornment>
							}}
						/>
						<FormHelperText error={props?.data?.error}>
							{props?.data?.error
								? props?.data?.error?.error
								: parsedHelperText?.[0]
								? parsedHelperText
								: props?.data?.help_message}
						</FormHelperText>
					</>
				) : (
					<>
						<TextField
							error={props?.data?.error}
							required={props?.data?.required}
							id="outlined-error-helper-text"
							name={name}
							inputRef={ref}
							disabled={disabled}
							defaultValue={defaultValue}
							InputLabelProps={{ shrink: isFormBuilder || undefined }}
							style={{ width: '100%' }}
							label={
								<>
									{isFormBuilder && getElementIcon(props.data?.key)}
									{parsedLabel?.[0] ? parsedLabel : props?.data?.label}
									{isFormBuilder && (
										<div>
											{props.data?.unique_identifier
												? `(ff-${props.data?.unique_identifier})`
												: `(tmp-${props.data?.temp_order})`}
										</div>
									)}
								</>
							}
							type="number"
						/>
						<FormHelperText error={props?.data?.error}>
							{props?.data?.error
								? props?.data?.error?.error
								: parsedHelperText?.[0]
								? parsedHelperText
								: props?.data?.help_message}
						</FormHelperText>
					</>
				)
			) : (
				<FormControl sx={{ width: '100%' }} variant="outlined">
					<StyledWrapper.CustomLabel
						value={defaultValue}
						disabled={disabled ? true : false}
						required={props?.data?.required}
						htmlFor="outlined-adornment-password"
					>
						{isFormBuilder && getElementIcon(props.data?.key)}
						{parsedLabel?.[0] ? parsedLabel : props?.data?.label}
						{isFormBuilder && (
							<div>
								{props.data?.unique_identifier
									? `(ff-${props.data?.unique_identifier})`
									: `(tmp-${props.data?.temp_order})`}
							</div>
						)}
					</StyledWrapper.CustomLabel>
					<StyledWrapper.OutlinedInputReadOnly
						id="outlined-adornment-password"
						type={'text'}
						disabled={disabled}
						style={{ width: '100%', border: '0px' }}
						inputComponent={() => {
							return (
								<StyledWrapper.RemoveBorderContainer>
									<TextField
										error={props?.data?.error}
										required={props?.data?.required}
										id="outlined-error-helper-text"
										name={name}
										inputRef={ref}
										disabled={disabled}
										defaultValue={formatBlurEvent(
											defaultValue,
											props?.data?.description === 'currency'
										)}
										style={{ width: '100%', borderWidth: '0px!important' }}
										type="string"
									/>
									<StyledWrapper.PlaceHolderText>
										{data?.min_value &&
											data?.max_value &&
											`(${data?.min_value}-${data?.max_value})`}
									</StyledWrapper.PlaceHolderText>
								</StyledWrapper.RemoveBorderContainer>
							);
						}}
						value={defaultValue || ''}
						label={parsedLabel?.[0] ? parsedLabel : props?.data?.label}
					/>
					<FormHelperText error={props?.data?.error}>
						{props?.data?.error
							? props?.data?.error?.error
							: parsedHelperText?.[0]
							? parsedHelperText
							: props?.data?.help_message}
					</FormHelperText>
				</FormControl>
			)}
		</>
	);
});

MUINumberInput.displayName = 'MUI_NumberInput';
Registry.register('MUI_NumberInput', MUINumberInput);
